import axios from "axios";
import { toast } from "react-toastify";

let is403Error = false;

const navigateToLogin = () => {
  localStorage.clear();
  window.location.href = "/";
};

/* Shared axios factory: bearer-token request interceptor + 401 auto-logout response interceptor. */
const createClient = (baseURL) => {
  const instance = axios.create({
    baseURL,
    headers: { "Content-type": "application/json" },
  });

  instance.interceptors.request.use(
    (config) => {
      const s_token = localStorage.getItem("access_token");
      if (!config.headers["Authorization"]) {
        config.headers["Authorization"] = `Bearer ${s_token}`;
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        if (!is403Error) {
          is403Error = true;
          toast.warn(
            "Your session has ended. Please log in again to continue.",
          );
          navigateToLogin();
        }
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

const axiosInstance = createClient(process.env.REACT_APP_API_BASE_URL);

/* Supply / supplier module — separate base URL so it can be pointed at a different
   backend (e.g. local Spring service) without disturbing the rest of the app. */
export const httpSupplier = createClient(
  process.env.REACT_APP_SUPPLIER_API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL,
);

export const httpClinicPos = createClient(
  process.env.REACT_APP_SUPPLIER_API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL,
);

export default axiosInstance;
